import braintree from 'braintree';

let currentIntegration;
let apiClient;

let setupBraintreeIntegration = function (conf) {

    console.log('Braintree setup: isInSandboxEnvironment=' + conf.isInSandboxEnvironment + ', paymentAmout=' + conf.paymentAmount);

    apiClient = new braintree.api.Client({
        authorization: conf.clientToken
    });

    braintree.setup(conf.clientToken, 'custom', {
        onReady: function(integration) {
            currentIntegration = integration;
            if (integration.paypal) {
                conf.onSetupReady(integration.deviceData);
            } else {
                conf.onSetupReady(integration.deviceData, true);
            }
        },

        onPaymentMethodReceived: function(event) {
            conf.onPaymentMethodReceived(event.nonce, event.type);
        },

        onError: function(error) {
            conf.onError(error);
        },

        dataCollector: {
            kount: { environment: conf.isInSandboxEnvironment ? 'sandbox' : 'production' },
            paypal: true
        },

        id: conf.id,
        locale: 'sv_se',
        hostedFields: {
            onFieldEvent: function (event) {
                if (event.type === 'fieldStateChange') {
                    conf.onCardValidation(event.target.fieldKey, event.isValid);
                }
            },
            number: { selector: '#card-number'},
            cvv: { selector: '#cvv', placeholder: 'XXX' },
            expirationDate: { selector: '#expiration-date', placeholder: decodeURI('MM%C3%85%C3%85') },
            styles: {
                // Style all elements
                'input': {
                    'font-size': '12pt',
                    'color': '#333333',
                    'padding-left': '5px'
                },

                // Styling a specific field
                '.number': {
                    //'font-family': 'monospace'
                },

                // Styling element state
                ':focus': {
                    'color': '#333333'
                },
                '.valid': {
                    'color': 'green'
                },
                '.invalid': {
                    'color': 'red'
                },

                // Media queries
                // Note that these apply to the iframe, not the root window.
                '@@media screen and (max-width: 700px)': {
                    'input': {
                        'font-size': '14pt'
                    }
                }
            }
        },
        paypal: {
            // This will be called as soon as the user completes the PayPal flow
            // Workaround: see https://github.com/braintree/braintree-web/issues/58
            onSuccess: function(nonce, email) {
                conf.onNewPaypalMethodCreated(nonce, email);
            },

            container: conf.paypalContainer,
            singleUse: false,
            amount: conf.paymentAmount,
            currency: 'SEK',
            headless: true,
            locale: 'sv_se'
        }
    });
};

export default {

    setup: setupBraintreeIntegration,

    initPaypalAuthFlow : function() {
        currentIntegration.paypal.initAuthFlow();
    },

    closePaypalAuthFlow: function () {
        currentIntegration.paypal.closeAuthFlow();
    },

    teardown : function(onTeardownComplete) {

        if (currentIntegration) {
            currentIntegration.teardown(onTeardownComplete);
        } else {
            onTeardownComplete();
        }
        currentIntegration = null;
    },

    verify3DSecure: function(nonce, amount, onVerificationComplete, onCanceled) {
        apiClient.verify3DS({
            amount: amount,
            creditCard: nonce,
            onUserClose: onCanceled
        },
        onVerificationComplete);
    }
};


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/checkout2/braintree-integration.js